import {
  MICROPIPETTE_TYPE,
  PROTOCOL_LAB_APPARATUS,
} from "@learningblocks/exp-constants/lib/Utilities";

export const { GLASS_TUBE, TUBE, TRASH, MICROPIPETTE_TIP_BOX } =
  PROTOCOL_LAB_APPARATUS;

export const { P2, P20, P200, P1000, TIP_S, TIP_M, TIP_L } = MICROPIPETTE_TYPE;

export const PIPETTE_BODY_COLOR_CHART = {
  [P2]: {
    color1: "#D67568",
    color2: "#A49448",
    color3: "#F79689",
    color4: "#D5B85C",
  },
  [P20]: {
    color1: "#E9CE78",
    color2: "#A49448",
    color3: "#F7DD89",
    color4: "#D5B85C",
  },
  [P200]: {
    color1: "#8BB975",
    color2: "#A49448",
    color3: "#B0E298",
    color4: "#8BB975",
  },
  [P1000]: {
    color1: "#3295BA",
    color2: "#A49448",
    color3: "#54BCE3",
    color4: "#3295BA",
  },
};

export const PLUNGER_COLOR_CHART = {
  [P2]: {
    color1: "#CB7569",
    color2: "#BE5648",
    color3: "#F79689",
    color4: "#B84B3D",
  },
  [P20]: {
    color1: "#D5B85C",
    color2: "#BD9C33",
    color3: "#F7DD89",
    color4: "#BEA03E",
  },
  [P200]: {
    color1: "#8BB975",
    color2: "#72A45B",
    color3: "#B0E298",
    color4: "#6C9F54",
  },
  [P1000]: {
    color1: "#3295BA",
    color2: "#156988",
    color3: "#54BCE3",
    color4: "#227B9D",
  },
};

export const PIPETTE_TIP_CHART = {
  [P2]: TIP_S,
  [P20]: TIP_M,
  [P200]: TIP_M,
  [P1000]: TIP_L,
};

export const PLUNGER_STATE = {
  RELEASE: "RELEASE",
  FIRST_STOP: "FIRST_STOP",
  SECOND_STOP: "SECOND_STOP",
  MIXING: "MIXING",
};

export const PLUNGER_TOOLTIP_TYPE = {
  MIXER: "MIXER",
  STOPPER: "STOPPER",
};

export const TOOLTIP_COLOR_CHART = {
  [PLUNGER_TOOLTIP_TYPE.STOPPER]: {
    color1: "#FAAC48",
  },
  [PLUNGER_TOOLTIP_TYPE.MIXER]: {
    color1: "#00AEEF",
  },
};

export const VOLUME_CHART = {
  [P2]: { min: 0.2, max: 2.0, rate: 0.01, dp: 2 },
  [P20]: { min: 2.0, max: 20.0, rate: 0.5, dp: 1 },
  [P200]: { min: 20, max: 200, rate: 1 },
  dp: 0,
  [P1000]: { min: 200, max: 1000, rate: 10, dp: 0 },
};

export const VOLUME_UPDATE_INTERVAL = 250;
